import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const verifyDocuments = async (listId) => {
  const builder = new UrlBuilder(`/verifications/verify-documents/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getVerificationData = async (listId) => {
  const builder = new UrlBuilder(`/verifications/get-verification-data/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAcceptableDocuments = async (listId) => {
  const builder = new UrlBuilder(`/verifications/get-acceptable-documents/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateVerificationResult = async (payload) => {
  const builder = new UrlBuilder(`/verifications/update-verification-result`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
